const translationsArray = window.boardMemberData?.translations || [];
const translations = {};

// Convert the array of objects to a single object for easier lookup
translationsArray.forEach(item => {
    translations[item.key] = item.value;
});

export function __(key) {
    return translations[key] || key;
}